import React, { useEffect } from "react";

function GoogleTranslator() {

  useEffect(() => {

    // Prevent loading the script multiple times
    if (document.getElementById("google-translate-script")) {
      return;
    }

    window.googleTranslateElementInit = () => {

      if (
        window.google &&
        window.google.translate &&
        window.google.translate.TranslateElement
      ) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,ml,ta,hi",
            autoDisplay: false
          },
          "google_translate_element"
        );
      }

    };

    const script = document.createElement("script");

    script.id = "google-translate-script";
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;

    document.body.appendChild(script);

  }, []);

  return (
    <div
      id="google_translate_element"
      className="google-translator"
    ></div>
  );
}

export default GoogleTranslator;